import Vue from 'vue'
import App from './App.vue'
import Env from '@common/libs/util.env.js'
import * as Sentry from 'dida-sentry-vue-sdk'
import { BrowserTracing } from '@sentry/tracing'
import packageInfo from '../package.json'

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    release: packageInfo.name + '@' + packageInfo.version,
    environment: Env.isEnvOnline ? 'online' : (Env.isEnvECS ? 'simu' : 'test'),
    dsn: 'https://a67ade8f56914eb8921e88b2b8bb9390@sentry.didapinche.com/79',
    integrations: [
      new BrowserTracing({
        tracingOrigins: ['localhost', 'capis.didapinche.com', 'capis-ecs.didapinche.com', 'capis-test.didapinche.com']
      })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0
  })
}

new Vue({
  render: h => h(App)
}).$mount('#app')
